import { useGetOpenWithFaireDesktopBreadcrumbOptions } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderOpenWithFaire/__internal__/useGetOpenWithFaireDesktopBreadcrumbOptions";
import { HeaderMobileHamburgerMenu } from "@faire/deprecated-retailer-visitor-shared/components/Header/mobile/HeaderMobileHamburgerMenu";
import { HeaderLink } from "@faire/deprecated-retailer-visitor-shared/components/Header/styled";
import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { route as openWithFaireRoute } from "@faire/web-api--source/routes/www/open-with-faire";
import { route as openWithFaireAcademyRoute } from "@faire/web-api--source/routes/www/open-with-faire/academy";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { Chevron } from "@faire/web/slate/icons/Chevron";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Breadcrumbs } from "@faire/web/ui/Breadcrumbs";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { FaireLogo } from "@faire/web/ui/logos/FaireLogo";
import * as React from "react";
import { useLocation } from "react-router-dom";

export const OpenWithFaireBreadcrumbs: React.FC = () => {
  const { isDesktopAndAbove } = useViewport();

  return (
    <Row align="center">
      {isDesktopAndAbove ? (
        <>
          <Spacer width="3x" />
          <OpenWithFaireBreadcrumbDesktop />
        </>
      ) : (
        <>
          <HeaderMobileHamburgerMenu />
          <OpenWithFaireBreadcrumbMobile />
        </>
      )}
    </Row>
  );
};

const OpenWithFaireFaireLogo = React.memo(() => {
  return (
    <HeaderLink to={home()}>
      <FaireLogo size={104} />
    </HeaderLink>
  );
});

const OpenWithFaireBreadcrumbDesktop: React.FC = () => {
  const openWithFaireBreadcrumbOptions =
    useGetOpenWithFaireDesktopBreadcrumbOptions();
  return (
    <>
      <OpenWithFaireFaireLogo />
      <Breadcrumbs options={openWithFaireBreadcrumbOptions} />
    </>
  );
};

const OpenWithFaireBreadcrumbMobile: React.FC = () => {
  const { pathname } = useLocation();

  if (pathMatchesRoute(pathname, openWithFaireRoute)) {
    return <OpenWithFaireFaireLogo />;
  }
  if (pathMatchesRoute(pathname, openWithFaireAcademyRoute)) {
    return (
      <HeaderLink to={openWithFaireRoute}>
        <Row align="center">
          <Chevron direction="left" />
          <Spacer width="1x" />
          <Typography variant="paragraphSansRegular">
            <StrictLocalMsg
              id="sox/wR"
              defaultMessage="Open with Faire"
              description={{
                text: "Name of a program we offer for helping opening retailers to start their business",
                img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
              }}
            />
          </Typography>
        </Row>
      </HeaderLink>
    );
  }
  return (
    <HeaderLink to={openWithFaireAcademyRoute}>
      <Row align="center">
        <Chevron direction="left" />
        <Spacer width="1x" />
        <Typography variant="paragraphSansRegular">
          <StrictLocalMsg
            id="dpQSIi"
            defaultMessage="Guides"
            description={{
              text: "Breadcrumb for Open With Faire Academy Guides",
              img: "https://cdn.faire.com/fastly/6d902468ba6925756736e5bf2e6aa4a4f76a19f0d97b73dc0a7a20634fc41fc3.png",
            }}
          />
        </Typography>
      </Row>
    </HeaderLink>
  );
};
